import { InnerView, SiteDeclaration } from "~/components";
import { FBProfile } from "~/.server/api";

interface ContactInnerViewProps {
  profile?: FBProfile;
}

export default function ContactInnerView({ profile }: ContactInnerViewProps) {
  return (
    <InnerView id="contact" title="Contact" showFooter={false} user={profile}>
      <div className="p-4 flex flex-col gap-2 text-text">
        <p>
          We are happy when our customers are happy! If you have any questions
          about our service, payment, or if you are experiencing any
          difficulties, please use the email address below.
        </p>
        <p>hello@flirtybum.com</p>
        <SiteDeclaration />
      </div>
    </InnerView>
  );
}
